<template>
  <v-container fluid>
    <v-card>
      <v-toolbar color="secondary" flat dense>
        <v-toolbar-title>Import Uom Stock</v-toolbar-title>
        <v-spacer></v-spacer>
      </v-toolbar>
      <v-card-text>
        <v-row>
          <v-col cols="12" xs="12" md="4">
                <v-autocomplete name="checkStockStore" dense outlined v-model="queryStore" :items="stores"
                  label="Select Shop" item-text="Name" item-value="id"></v-autocomplete>
              </v-col>

          <v-col cols="6">
            <v-file-input name="productExcelFile" v-model="excelFile" label="Browse Excel Sheet" outlined
              dense></v-file-input>
          </v-col>

          <!-- <v-col cols="12" xs="12" sm="12" md="4">
              <DatePicker @date="setDate" :myDate="date" :title="`Date`"></DatePicker>
            </v-col>-->

          <v-col cols="12">
            <v-btn color="primary" @click="uploadExcel" :loading="$store.state.btnLoader">
              <v-icon left>mdi-upload</v-icon>Upload Uom Stock
            </v-btn>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
    <!-- snackbar -->
    <snackbar ref="snackbar"></snackbar>
  </v-container>
</template>

<script>
export default {
  components: {},
  data: () => ({
    search: "",
    queryStore: null,
    stores: [],
    loader: false,
    excelFile: null,
    date: null
  }),
  methods: {
    setDate(myDate) {
      this.date = myDate;
    },
    uploadExcel() {
      var store_id = this.queryStore;
      var subscriber_id = localStorage.getItem("subscriber_id");

      const data = new FormData();
      data.append("documentData", this.excelFile);
      data.append("store_id", parseInt(store_id));
      data.append("subscriber_id", parseInt(subscriber_id));
      this.$store.commit("btnLoader", true);
      const url = "/import-uom-stock";
      const self = this;
      this.$store
        .dispatch("post", { url, data })
        .then((res) => {
          if (res.ResultCode == 1200) {
            self.$refs.snackbar.show(
              "Products imported successfully",
              "green"
            );
            self.$store.commit("btnLoader", false);
            self.excelFile = null;
          } else {
            self.$store.commit("btnLoader", false);
            self.$refs.snackbar.show(res.ResultDesc, "red");
          }
        })
        .catch((err) => {
          self.$store.commit("btnLoader", false);
          this.$refs.snackbar.show(err, "red");
        });
      // end
    },
    getStores() {
      const self = this;
      this.$store
        .dispatch("get", `/stores`)
        .then((res) => {
          if (res.ResultCode == 1200) {
            self.stores = res.ResponseData;
          } else {
            this.$refs.snackbar.show(res.msg, "red");
          }
        })
        .catch((err) => {
          this.$refs.snackbar.show(err, "red");
        });
    },
  },
  created() {
    Promise.all([this.getStores()]);
  },
};
</script>